module.exports = __webpack_public_path__ + "static/media/bottlings9.f3f9c50c.jpg";